import React from "react";
import RingLoader from "react-spinners/RingLoader";

const override = {
  display: "flex",
  justifyContent: "center",
  margin: "0 auto",
  borderColor: "red",
};

const Loader = () => {
  let loading = true;

  return (
    // <RingLoader
    //   color={"#000"}
    //   loading={loading}
    //   cssOverride={override}
    //   size={100}
    //   aria-label="Loading Spinner"
    //   data-testid="loader"
    // />
      <div className="flex justify-center items-center">
      <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-gray-900"></div>
    </div>
  );
};

export default Loader;
